module.exports = __webpack_public_path__ + "img/company42.a7e06867.png";